<div class="wrapper" [ngClass]="modalPaddingSize">
  <ng-content></ng-content>
</div>
